<template>
  <div>
    <b-modal
      id="abandon-race-modal"
      title="Abandon Race"
      hide-footer
      centered
      size="lg"
    >
      <p class="text-muted mb-1">
        You are about to abandon {{ raceName }}. This action cannot be undone.
      </p>

      <div
        class="p-1 text-danger"
        style="
          background: #fdecec;
          border: 1px solid #f3bbbb;
          border-radius: 8px;
        "
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="AlertTriangleIcon"
            size="16"
            class="text-danger mr-1"
          />
          <strong class="text-danger">Warning</strong>
        </div>

        <p class="mb-0">Abandoning this race will:</p>
        <ul class="pl-2 mb-0">
          <li>Cancel all active bets and refund customers</li>
          <li>Stop all betting activity for this race</li>
          <li>Mark the race as abandoned</li>
          <li>Send notifications to affected customers</li>
        </ul>
      </div>

      <!-- STATS -->
      <div class="d-flex justify-content-around text-center my-1 text-black">
        <div>
          <feather-icon size="20" icon="UsersIcon" class="mb-1" />
          <h5 class="mb-0">{{ stats.activeBets }}</h5>
          <small class="text-muted">Active Bets</small>
        </div>

        <div>
          <feather-icon size="20" icon="DollarSignIcon" class="mb-1" />
          <h5 class="mb-0">
            {{ formatCurrencyBuiltInFunc(stats.totalStakes) }}
          </h5>
          <small class="text-muted">Total Stakes</small>
        </div>

        <div>
          <feather-icon size="20" icon="AlertTriangleIcon" class="mb-1" />
          <h5 class="mb-0">
            {{ formatCurrencyBuiltInFunc(stats.totalLiability) }}
          </h5>
          <small class="text-muted">Total Liability</small>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="$bvModal.hide('abandon-race-modal')"
        >
          Cancel
        </b-button>

        <b-button variant="danger" @click="reviewBets"> Review Bets </b-button>
      </div>
    </b-modal>

    <ReviewABandonRaceModal @onFetchRaces="$emit('onFetchRaces')" />
  </div>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import ReviewABandonRaceModal from "./ReviewABandonRaceModal.vue";

export default {
  components: {
    BModal,
    BButton,
    FeatherIcon,
    ReviewABandonRaceModal,
  },
  data() {
    return {
      raceName: "Randwick R1",
      stats: {
        activeBets: 8,
        totalStakes: 5150,
        totalLiability: 32000,
      },
    };
  },
  methods: {
    formatCurrencyBuiltInFunc,
    reviewBets() {
      this.$bvModal.hide("abandon-race-modal");
      this.$bvModal.show("cancel-bets-modal");
    },
  },
};
</script>
